import { render, staticRenderFns } from "./MyTeachers.vue?vue&type=template&id=20eafb6e&scoped=true"
import script from "./MyTeachers.vue?vue&type=script&lang=js"
export * from "./MyTeachers.vue?vue&type=script&lang=js"
import style0 from "./MyTeachers.vue?vue&type=style&index=0&id=20eafb6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eafb6e",
  null
  
)

export default component.exports